import GraphQLService from './GraphQLService'
import { removeExtraSpaces } from '../common/helpers'
import { mapSchemaPlaceholderGql } from './mappers/mapSchemaPlaceholderGql'
import { loggedGraphqlQuery } from './loggedGraphqlQuery'

export default class SchemaPlaceholderService extends GraphQLService {
  /**
   * Schema placeholder row by normalized page path.
   * @param {string} path — path with trailing slash (e.g. `why-were-better/`)
   * @param {boolean} [preview=false]
   */
  async getByPath(path, preview = false) {
    const query = removeExtraSpaces(`
      query SchemaPlaceholderByPath($preview: Boolean, $path: String!) {
        placeholder: schemaPlaceholderPageCollection(
          preview: $preview
          limit: 1
          where: { path: $path }
        ) {
          items {
            path
            sys { id publishedAt }
            jsonLdSchemasCollection(preview: $preview) {
              items {
                ... on SchemaEntity {
                  jsonld
                  slug
                  sys { id }
                }
              }
            }
          }
        }
      }
    `)

    const data = await loggedGraphqlQuery(
      'SchemaPlaceholderService.getByPath',
      () => this.run(query, preview, { path }),
      {
        context: { path, preview },
        countItems: (d) => d?.placeholder?.items?.length ?? null,
      }
    )
    const item = data?.placeholder?.items?.[0]

    return mapSchemaPlaceholderGql(item)
  }
}
